import React from "react"
import { Box, Flex, Heading, Text, IconButton } from "@radix-ui/themes"
import { Menu } from "lucide-react"
import { useLanguage } from "../../../contexts/LanguageContext"
import NotificationBell from "../../NotificationBell"
import ProfileDropdown from "../../ProfileDropdown"

interface UnifiedHeaderProps {
  onMenuClick?: () => void
  title?: string
  subtitle?: string
  user?: {
    username?: string
    name?: string
    role?: string
  } | null
  onLogout?: () => void
  showNotifications?: boolean
  showUserMenu?: boolean
  children?: React.ReactNode
  profilePath?: string
  isRestaurant?: boolean
  restaurantId?: string
}

const UnifiedHeader: React.FC<UnifiedHeaderProps> = ({
  onMenuClick,
  title = "Dashboard",
  subtitle,
  user,
  onLogout,
  showNotifications = true,
  showUserMenu = true,
  children,
  profilePath = "/admin/profile",
  isRestaurant = false,
  restaurantId
}) => {
  const { language } = useLanguage()

  return (
    <Box asChild>
      <header style={{
        borderBottom: '1px solid var(--gray-6)',
        backgroundColor: 'var(--color-background)',
        boxShadow: 'var(--shadow-1)'
      }}>
        <Flex align="center" justify="between" px="6" style={{ height: '64px' }}>
          <Flex align="center" gap="4">
            {onMenuClick && (
              <IconButton
                variant="ghost"
                size="2"
                onClick={onMenuClick}
                className="lg:hidden"
              >
                <Menu className="w-6 h-6" />
              </IconButton>
            )}

            <Box>
              <Heading size="6" mb="1">
                {title}
              </Heading>
              {subtitle && (
                <Text size="2" color="gray">
                  {subtitle}
                </Text>
              )}
            </Box>
          </Flex>

          <Flex align="center" gap="2">
            {/* Custom content */}
            {children}

            {/* Notifications */}
            {showNotifications && <NotificationBell />}

            {/* User Profile Dropdown */}
            {showUserMenu && user && onLogout && (
              <ProfileDropdown
                user={user}
                onLogout={onLogout}
                profilePath={profilePath}
                isRestaurant={isRestaurant}
                restaurantId={restaurantId}
              />
            )}
          </Flex>
        </Flex>
      </header>
    </Box>
  )
}

export default UnifiedHeader 